import { render, staticRenderFns } from "./AccountInfo.vue?vue&type=template&id=6be8704a&scoped=true&"
import script from "./AccountInfo.vue?vue&type=script&lang=ts&"
export * from "./AccountInfo.vue?vue&type=script&lang=ts&"
import style0 from "./AccountInfo.vue?vue&type=style&index=0&id=6be8704a&lang=less&scoped=true&"
import style1 from "./AccountInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be8704a",
  null
  
)

export default component.exports